/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import Preloader from "components/Preloader/Preloader";
import ToastMessage from "components/ToastMessage/ToastMessage";
import EmptyView from "views/components/EmptyView/EmptyView";
import ListComponent from "./ListComponent/ListComponent";
//#endregion
//#region Services
import { currentUserLocalStorage } from "services/storage/general";
import { requestUserHasAcadReinforce } from "services/acadReinforce/aboutAcadReinforce";
//#endregion
//#region Utils
import { USER_ROLES } from "config/userPermissions";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
//#endregion

const DROPDOWN_BUTTON_PROPS_FOR_EMPTY_VIEW = {
    text: "Crear refuerzo",
    items: [
        { path: ABSOLUTE_PATHS.CREATE_ACAD_REINFORCE_MANUAL_LOADING, text: "Carga manual" },
        { path: ABSOLUTE_PATHS.CREATE_ACAD_REINFORCE_MASSIVE_LOADING, text: "Carga masiva" }
    ]
};

const AcadReinforceListView = ({
    userRole
}) => {
    const isTutorUser = (userRole === USER_ROLES.REF_ACAD_TUTOR || userRole === USER_ROLES.EVENTOS_DOCENTE);
    const toastMessageSuccess = useToastMessage();
    //#region States
    const [currentUserHasAcadReinforce, setCurrentUserHasAcadReinforce] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        verifyIfCurrentUserHasAcadReinforce();
    }, [userRole]);
    //#endregion
    //#region Functions
    const verifyIfCurrentUserHasAcadReinforce = async () => {
        if (!userRole) return;
        const { id: userCode } = currentUserLocalStorage.get() || { id: null };
        if (!userCode) return;
        const hasAcadReinforce = await requestUserHasAcadReinforce(userCode, isTutorUser);
        setCurrentUserHasAcadReinforce(hasAcadReinforce);
    }
    //#endregion
    return (
        <>
            <HelmetUTP title="Ref. A."/>
            <ToastMessage 
                {...toastMessageSuccess.value}
                variant="success"/>
            <Preloader 
                message="Cargando..." 
                hidden={currentUserHasAcadReinforce !== null}/>
            {currentUserHasAcadReinforce !== null 
            && (
                currentUserHasAcadReinforce
                ? <ListComponent 
                    userRole={userRole}
                    isTutorUser={isTutorUser}
                    toastMessageSuccess={toastMessageSuccess}/>
                : <EmptyView
                    isCoordinator={!isTutorUser}
                    dropDownButtonProps={DROPDOWN_BUTTON_PROPS_FOR_EMPTY_VIEW}
                    as="tutor"/>
                )}
        </>
    );
}

export default AcadReinforceListView;